<template>
	<div id="app">
		<!--<transition name="bounce">-->
			<router-view></router-view>
		<!--</transition>-->
	</div>
</template>

<script>

	export default {
		name: 'app',
		components: {
		},
		mounted() {
		},
		methods: {
		}
	}
</script>

<style type="text/css">
	@import "../../../node_modules/font-awesome/css/font-awesome.min.css";
	@import "../../../node_modules/flex.css/dist/flex.css";
	.bounce-enter-active {
		animation: bounce-in .5s;
	}
	
	.bounce-leave-active {
		animation: bounce-out .2s;
	}
	
	@keyframes bounce-in {
		0% {
			transform: scale(0);
		}
		50% {
			transform: scale(1.05);
		}
		100% {
			transform: scale(1);
		}
	}
	
	@keyframes bounce-out {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(0.95);
		}
		100% {
			transform: scale(0);
		}
	}



	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s
	}
	.fade-enter, .fade-leave-active {
		opacity: 0
	}
	
	#app {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
	}
	
	.el-submenu [class^=fa] {
		vertical-align: baseline;
		margin-right: 10px;
	}
	
	.el-menu-item [class^=fa] {
		vertical-align: baseline;
		margin-right: 10px;
	}
</style>


// WEBPACK FOOTER //
// App.vue?0cca4640